import checkPermission from "@/middleware/checkPermission.js";

function importFromTripsDir(dir, pageName) {
    return () =>
        import(`../pages/Trips/${dir}/${pageName}.vue`).then(
            (m) => m.default || m,
        );
}
function importFromTripsSettingDir(dir, pageName) {
    return () =>
        import(`../pages/Trips/Setting/${dir}/${pageName}.vue`).then(
            (m) => m.default || m,
        );
}

function importFromTrips(pageName) {
    return () =>
        import(`../pages/Trips/${pageName}.vue`).then((m) => m.default || m);
}

export default [
    {
        path: "/tours/info/settings",
        name: "tripinfo",
        component: importFromTripsDir("TripInfo", "Index"),
        meta: {
            title: "Tour Info",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/activity-listing",
        name: "activity-listing",
        component: importFromTripsDir("Activity", "Index"),
        meta: {
            title: "Activity",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/activities/create",
        name: "create-activity",
        component: importFromTripsDir("Activity", "Create"),
        meta: {
            title: "Create-Activity",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/activities/edit/:slug",
        name: "update-activity",
        component: importFromTripsDir("Activity", "Create"),
        meta: {
            title: "Update-Activity",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/destinations/create",
        name: "create-destination",
        component: importFromTripsDir("Destination", "Create"),
        meta: {
            title: "Create-Destination",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/destinations/edit/:slug",
        name: "update-destination",
        component: importFromTripsDir("Destination", "Update"),
        meta: {
            title: "Update-Destination",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/difficulties/settings",
        name: "difficulty-level",
        component: importFromTripsDir("Setting", "DifficultyLevel"),
        meta: {
            title: "Difficulty Level",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tour-listing",
        name: "tour-listing",
        component: importFromTrips("TripsList"),
        meta: {
            title: "All Tours",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/create",
        name: "trips-create",
        component: importFromTrips("Create"),
        meta: {
            title: "Create Tours",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/edit/:slug",
        name: "trips-edit",
        component: importFromTrips("Edit"),
        meta: {
            title: "Edit Tours",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/trip-itinerary",
        name: "trip-itinerary",
        component: importFromTrips("TripItinerarySetting"),
        meta: {
            title: "Trip Itinerary",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/trip-include-exclude",
        name: "trip-include-exclude",
        component: importFromTrips("TripIncludesSetting"),
        meta: {
            title: "Trip Include-Exclude",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/trip-map",
        name: "trip-map",
        component: importFromTrips("TripMapSetting"),
        meta: {
            title: "Trip Map",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/site/seo/settings",
        name: "seo",
        component: importFromTripsDir("Setting", "Seo"),
        meta: {
            title: "SEO",
        },
    },
    {
        path: "/notifications/settings",
        name: "notifications",
        component: importFromTripsSettingDir("Email", "Index"),
        meta: {
            title: "Notifications",
        },
    },
    {
        path: "/tours/settings/tour-tabs",
        name: "tour-tabs",
        component: importFromTripsDir("TripTabs", "Index"),
        meta: {
            title: "Tour Tabs",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/settings/miscellaneous",
        name: "miscellaneous",
        component: importFromTripsDir("Setting", "Miscellaneous"),
        meta: {
            title: "Miscellaneous",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/settings/tour-filters",
        name: "tour-filters",
        component: importFromTripsSettingDir("TourFilters", "Index"),
        meta: {
            title: "Tour Filters",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/trip-name",
        name: "trip-name",
        component: importFromTrips("TripDetail"),
        meta: {
            title: "Trip Detail",
        },
    },
    {
        path: "/destination-listing",
        name: "destination-listing",
        component: importFromTripsDir("Destination", "Index"),
        meta: {
            title: "Destination",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/settings/currency",
        name: "currency-setting",
        component: importFromTripsDir("CurrencySwitcher", "Index"),
        meta: {
            title: "Currency",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/settings/block-dates",
        name: "block-dates",
        component: importFromTrips("BlockDates"),
        meta: {
            title: "Block Dates",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },

    {
        path: "/tours/settings/price-categories",
        name: "trip-pricing-category",
        component: importFromTripsDir("Setting", "PriceCategory"),
        meta: {
            title: "Pricing Category",
            auth: true,
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/extra-services/settings",
        name: "trip-extra-services",
        component: importFromTripsSettingDir("ExtraServices", "Index"),
        meta: {
            title: "Add-ons",
            auth: true,
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/extra-services/create",
        name: "trip-extra-services-create",
        component: importFromTripsSettingDir("ExtraServices", "Create"),
        meta: {
            title: "Create- Add-ons",
            auth: true,
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/extra-services/edit/:slug",
        name: "trip-extra-services-edit",
        component: importFromTripsSettingDir("ExtraServices", "Update"),
        meta: {
            title: "Update - Add-ons",
            auth: true,
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/tours/accommodation/settings",
        name: "accommodation",
        component: importFromTripsSettingDir("GlobalRoomSetting", "Index"),
        meta: {
            title: "Accommodation",
            auth: true,
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
    {
        path: "/media-listing",
        name: "media",
        component: () => import("../pages/Gallery/Index.vue"),
        meta: {
            title: "Media",
        },
    },
    {
        path: "/tours/settings/deposit-payment",
        name: "deposit-payment",
        component: importFromTripsDir("Setting", "DepositPayment"),
        meta: {
            title: "Deposit Payment",
            middleware: [checkPermission],
            permissions: ["manage_tours"],
        },
    },
];
